import api from "api";
import { Option } from "../components/styled/async-search-select-v2/AsyncSearchSelectV2.types";

interface ServiceLine {
  name: string;
  id?: string;
}

/**
 * Fetches service lines from the API for use in dropdown/select components
 * @param search - Search term to filter service lines
 * @returns Array of Option objects for use in AsyncSearchSelectV2
 */
export const fetchServiceLines = async (search: string): Promise<Option[]> => {
  try {
    const response = await api.client.ServiceLine.list({
      search: search,
      size: 50,
    });

    if (response.body) {
      return response.body.map((serviceLine: ServiceLine) => ({
        value: serviceLine.name,
        label: serviceLine.name,
      }));
    }
    return [];
  } catch (error) {
    console.error("Error fetching service lines:", error);
    return [];
  }
};

/**
 * Creates a service line option (used when creating new service lines in forms)
 * @param name - Name of the service line to create
 * @returns Object with data structure expected by AsyncSearchSelectV2
 */
export const createServiceLine = async (name: string) => {
  try {
    await api.client.ServiceLine.create({
      body: {
        service_line: {
          name: name,
        },
      },
    });
    return { data: { id: name } };
  } catch (error) {
    console.error("Error creating service line:", error);
    throw error;
  }
};
